var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHousingWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Grupo_12922",
    width: 36.5,
    height: 36.504,
    viewBox: "0 0 36.5 36.504",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#fff}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11758",
    transform: "translate(5.954 15.95)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_4376",
    d: "M0 0H6.737V3.392H0z",
    className: "cls-1"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11760",
    transform: "translate(14.153 25.422)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_4378",
    d: "M0 0H6.779V3.391H0z",
    className: "cls-1"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11761",
    transform: "translate(14.153 15.948)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_4379",
    d: "M0 0H6.779V3.392H0z",
    className: "cls-1"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11762",
    transform: "translate(10.374 20.707)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_4380",
    d: "M0 0H7.941V3.391H0z",
    className: "cls-1"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11763",
    transform: "translate(5.957 20.707)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_4381",
    d: "M0 0H2.917V3.391H0z",
    className: "cls-1"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11764",
    transform: "translate(5.957 25.422)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_4382",
    d: "M0 0H6.737V3.391H0z",
    className: "cls-1"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11765",
    transform: "translate(5.957 30.179)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_4383",
    d: "M0 0H2.917V3.39H0z",
    className: "cls-1"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11766",
    transform: "translate(10.374 30.179)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_4384",
    d: "M0 0H7.941V3.39H0z",
    className: "cls-1"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11757"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25666",
    d: "M311.587 143.193a1.247 1.247 0 0 1-1.228-1.193v-19.04a.85.85 0 0 1 .044-.329v-1.716l-1.455 1.122a1.16 1.16 0 0 1-.809.261 1.134 1.134 0 0 1-.906-.4 1.212 1.212 0 0 1-.3-.931 1.167 1.167 0 0 1 .443-.787l3.023-2.345v-5.792a1.283 1.283 0 1 1 2.567 0v3.837l11.537-8.917a1.953 1.953 0 0 1 1.523-.2 4.038 4.038 0 0 1 1.114.745c.6.475 1.2.943 1.806 1.409l5.665 4.445c1.931 1.519 3.817 3 5.745 4.479l2.671 2.071a1.188 1.188 0 0 1 .1 1.668 1.374 1.374 0 0 1-1.745.163l-.532-.4-.012 20.789a1.246 1.246 0 0 1-1.3 1.065h-27.896zm-.167-24.347v4l-.051.106.007 19.032a.232.232 0 0 0 .237.193h27.961c.158-.009.257-.089.265-.212v-22.68l2.147 1.635a.344.344 0 0 0 .418-.047.225.225 0 0 0-.053-.2l-2.614-2.024c-1.93-1.481-3.82-2.964-5.753-4.485l-5.663-4.443c-.6-.466-1.2-.936-1.846-1.444a3.189 3.189 0 0 0-.808-.565.951.951 0 0 0-.608.107l-13.109 10.136v-5.91c0-.293-.53-.293-.53 0v6.291l-3.42 2.647a.161.161 0 0 0-.023.226.2.2 0 0 0 .166.071.225.225 0 0 0 .165-.039z",
    className: "cls-1",
    transform: "translate(-306.928 -106.688)"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11759",
    transform: "translate(19.813 20.667)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_4377",
    d: "M0 0H7.723V3.392H0z",
    className: "cls-1"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11767",
    transform: "translate(19.859 30.179)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_4385",
    d: "M0 0H7.724V3.39H0z",
    className: "cls-1"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHousingWhite);
export default __webpack_public_path__ + "static/media/housing-white.2a318331371fbb4830a129bcb933ac81.svg";
export { ForwardRef as ReactComponent };